"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMinimalUserObject = exports.isUserLike = exports.User = exports.UserClassName = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const Person_1 = require("./Person");
exports.UserClassName = 'User';
class User extends Person_1.Person {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.UserClassName)
            throw new Error(`Tried to create a ${exports.UserClassName} from a ${ob.type} object!`);
        super(ob); // can't use this.constructor.name as will fail in lambda as gets Class name appended twice
        this.type = ob.type ?? exports.UserClassName;
        this.username = ob.username;
        this.creation_date = ob.creation_date;
        this.last_login = ob.last_login;
        this.IdentityId = ob.IdentityId;
    }
    getUserAttributes() {
        return {
            username: {
                type: 'String',
                label: 'Username',
                editable: false,
                required: true,
            },
            ...super.getUserAttributes(),
            creation_date: {
                type: 'Date',
                label: 'Creation date',
                editable: false,
                required: false,
            },
            last_login: {
                type: 'Date',
                label: 'Last login',
                editable: false,
                required: false,
            },
            /** 2024 02 removed as replaced in edgeTypeMatrix */
            // Customer: {
            //   type: 'RelatedType',
            //   direction: PathDirection.parent,
            //   edgeTypeId: 'customer_has_users',
            //   editable: false,
            // },
        };
    }
}
exports.User = User;
const isUserLike = (ob) => {
    return (0, iotv_v3_types_1.isValidBusinessObject)(ob) && ob.type === exports.UserClassName;
};
exports.isUserLike = isUserLike;
const isMinimalUserObject = (ob) => {
    return (0, exports.isUserLike)(ob) && typeof ob.username === 'string' && 0 < ob.username.length;
};
exports.isMinimalUserObject = isMinimalUserObject;
